import { motion } from "framer-motion";
import { ReactNode } from "react";

type ErrorMessageFramerProps = {
  children: ReactNode; // Optional children prop
};

export default function ErrorMessageFramer({ children }: ErrorMessageFramerProps) {
  const errorVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0 },
  };
  return (
    <motion.div
      variants={errorVariants}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  );
}
